import React, { useState, useRef, useEffect } from 'react';
import { Switch, Button, Col, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography, InputNumber, DatePicker } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {insert, update, getById} from '../../../../apis/SaldosEmpleadoApi';
import {getList as getAllTipoSaldo} from '../../../../apis/TipoSaldoApi';
import {getList as getAllPeriodos} from '../../../../apis/PeriodosApi';

import {getEmpleados} from '../../../../apis/OdooApi';
import _ from 'lodash';
import dayjs from 'dayjs';

const { Option } = Select;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [tipoSaldos, setTipoSaldos] = useState([]);
    const [tipoPeriodo, setTipoPeriodo] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [tipoSaldo, setTipoSaldo] = useState(null);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if(!values) return;
            
            // Validate that discount is not zero
            if (values.descuento === 0) {
                message.error('El descuento no puede ser cero');
                return;
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        let success = false;
        const fields = form.getFieldsValue()
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                concepto_id: tipoSaldo.concepto.id,
                ...fields
            }
            const response = await update(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se actualizó correctamente el saldo!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                concepto_id: tipoSaldo.concepto.id,
                ...fields
            }
            const response = await insert(payload);
            success = response.ok;
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el saldo!');
            }
        }

        if(success){
            setModified(true);
            onClose(true);
        }
    }

    const onClose = (reload)=>{
      finish(reload ?? modified);
      setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
                await getEmpleadosOdoo();

                if(ID > 0){
                    await refreshData();
                }else{
                    // Set default values with zeros for new records
                    setInitialValues({
                        activo: true,
                        monto_inicial: 0,
                        descuento: 0,
                        saldo_actual: 0,
                        fecha_inicio: dayjs()
                    });
                }
                setModified(false)
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
        (async () => {
            if(tipoSaldos.length > 0 && initialValues?.tipo_saldo_id > 0){
                await changeTipoSaldo(initialValues.tipo_saldo_id);
            }
        })();
    }, [tipoSaldos, initialValues]);


    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
            let item = response.payload;
            // Convert date strings to dayjs objects for DatePicker
            if (item.fecha_inicio) {
                item.fecha_inicio = dayjs(item.fecha_inicio);
            }
            if (item.fecha_suspension) {
                item.fecha_suspension = dayjs(item.fecha_suspension);
            }
            setInitialValues(item);
        }
    }
    
    const getCatalogs = async ()=> {
        const responsePeriodos = await getAllPeriodos();
        if(responsePeriodos.ok){
          let items = responsePeriodos.payload;
          setTipoPeriodo(items);
        }

        const responseTipoSaldo = await getAllTipoSaldo();
        if(responseTipoSaldo.ok){
          let items = responseTipoSaldo.payload;
          setTipoSaldos(items);
        }
    }

    const getEmpleadosOdoo = async ()=>{
        const response = await getEmpleados();
        if(response.ok){
            let items = response.payload;
            setEmpleados(items);
        }
    }

    const changeTipoSaldo = async (value) => {
        var _tipoSaldo = tipoSaldos.find(x=>x.value == value)
        if(!_tipoSaldo){return;}
        setTipoSaldo(_tipoSaldo);

        form.setFieldsValue({
            ...initialValues,
            concepto_tipo_saldo: _tipoSaldo.concepto.displayTitle,
        });
    }

    return (
        <Drawer
            title={title}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={<Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>}
        >
            <>
                <div>
                    <div style={{float: 'left'}}>
                        <span title=""></span>
                    </div>
                    <span className="" style={{float:'right'}}>
                       
                    </span>
                </div>
            {
                initialValues && 
                <Form 
                        layout="vertical" 
                        form={form} 
                        requiredMark 
                        autoComplete="off"
                        initialValues={initialValues} 
                        onFinish={handleOk}>
                        <Row gutter={16}>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="odoo_empleado_id"
                                    label="Empleado"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Selecciona un empleado',
                                    },
                                    ]}
                                >
                                     <Select placeholder="Por favor selecciona un empleado">
                                        {
                                            empleados.map((item)=><Option key={item.value} value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="periodo_id"
                                    label="Tipo Periodo"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona un tipo de periodo',
                                    },
                                    ]}
                                >
                                    <Select placeholder="Por favor selecciona un tipo de periodo">
                                        {
                                            tipoPeriodo.map((item)=><Option key={item.value} value={item.value}>{item.text}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="tipo_saldo_id"
                                    label="Tipo de Saldo"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona un tipo de saldo',
                                    },
                                    ]}
                                >
                                    <Select placeholder="Por favor selecciona un tipo de saldo" 
                                        onChange={changeTipoSaldo}>
                                        {
                                            tipoSaldos.map((item)=><Option key={item.value} value={item.value}>{item.displayTitle}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="referencia_tipo_saldo"
                                    label="Referencia Tipo Saldo"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor ingrese una referencia',
                                    },
                                    ]}
                                    >
                                    <Input placeholder="..." />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="concepto_tipo_saldo"
                                    label="Concepto"
                                    disabled={true}
                                    >
                                    <Input placeholder="Por favor agrega la referencia" disabled={true}/>
                                </Form.Item>
                            </Col>
                            {/* New date fields */}
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="fecha_inicio"
                                    label="Fecha de Inicio"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor selecciona una fecha de inicio',
                                    },
                                    ]}>
                                    <DatePicker 
                                        placeholder="Selecciona la fecha de inicio"
                                        style={{width: '100%'}}
                                        format="DD/MM/YYYY"
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="fecha_suspension"
                                    label="Fecha de Suspensión"
                                    >
                                    <DatePicker 
                                        placeholder="Selecciona la fecha de suspensión (opcional)"
                                        style={{width: '100%'}}
                                        format="DD/MM/YYYY"
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="monto_inicial"
                                    label="Monto Inicial"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un monto inicial',
                                    },
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega un monto inicial"  style={{width: '80%',}}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="descuento"
                                    label="Descuento"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un descuento',
                                    },
                                    {
                                        validator: (_, value) => {
                                            if (value === 0) {
                                                return Promise.reject('El descuento no puede ser cero');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega un descuento" style={{width: '80%',}}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="saldo_actual"
                                    label="Saldo Actual"
                                    rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega un saldo actual',
                                    },
                                    ]}>
                                    <InputNumber placeholder="Por favor agrega un saldo actual" style={{width: '80%',}}/>
                                </Form.Item>
                            </Col>
                            <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                                <Form.Item
                                    name="activo"
                                    label="Activo"
                                    >
                                    <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                                </Form.Item>
                            </Col>
                        </Row>
                </Form>
            }
            </>
        </Drawer>
    );
};
export default App;